const WORKFLOW_PROGRESS_REFRESH_DELAYS_MS = [0, 1_500, 3_500, 7_000, 12_000, 20_000];

export function refreshTprWorkflowProgress(refresh: () => void): void {
  for (const delay of WORKFLOW_PROGRESS_REFRESH_DELAYS_MS) {
    window.setTimeout(refresh, delay);
  }
}
